module.exports = __webpack_public_path__ + "static/media/ai_review_keyword.2dab4802.png";